// @flow

import React from 'react';

import Switch from './Switch';

type Props = {
  locked: boolean,
  on: boolean,
  onToggle: Function,
};

const Toggle = ({ on, locked, onToggle }: Props) => (
  <Switch on={on} onClick={onToggle} className={locked ? 'locked' : ''} />
);

export default Toggle;



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/Preferences/Toggle.jsx